module.exports = __webpack_public_path__ + "static/media/onboarding_tour_slide4.5351a512.png";